import React from "react";
import PropTypes from "prop-types";
import Grid from "../Grid";
import Text from "../Text";
import VisuallyHidden from "../VisuallyHidden";
import useTheme from "../../hooks/useTheme";
import { jsx as ___EmotionJSX } from "@emotion/core";

function Field(_ref) {
  var _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? true : _ref$fullWidth,
      optional = _ref.optional,
      disabled = _ref.disabled,
      label = _ref.label,
      _ref$hideLabel = _ref.hideLabel,
      hideLabel = _ref$hideLabel === void 0 ? false : _ref$hideLabel,
      _ref$renderLabel = _ref.renderLabel,
      renderLabel = _ref$renderLabel === void 0 ? true : _ref$renderLabel,
      labelId = _ref.labelId,
      labelFor = _ref.labelFor,
      auxId = _ref.auxId,
      helpText = _ref.helpText,
      errors = _ref.errors,
      children = _ref.children,
      testId = _ref.testId;
  var theme = useTheme();
  var labelToRender = null;

  if (renderLabel) {
    var LabelElement = labelFor ? "label" : "div";

    var labelContent = ___EmotionJSX(LabelElement, {
      css: theme.field.getCSS({
        targetElement: "label"
      }),
      id: labelId,
      htmlFor: labelFor
    }, label, optional && ___EmotionJSX("span", {
      css: theme.field.getCSS({
        targetElement: "optionalTag"
      })
    }, "Optional"));

    labelToRender = hideLabel ? ___EmotionJSX(VisuallyHidden, null, labelContent) : labelContent;
  }

  return ___EmotionJSX("div", {
    css: theme.field.getCSS({
      targetElement: "fieldContainer",
      fullWidth: fullWidth,
      disabled: disabled
    }),
    "data-testid": testId
  }, labelToRender, children, Array.isArray(errors) && errors.length > 0 ? ___EmotionJSX("div", {
    css: theme.field.getCSS({
      targetElement: "errorsContainer"
    }),
    id: auxId
  }, ___EmotionJSX(Grid, {
    cols: 1,
    rowsGap: 1
  }, errors.map(function (error, index) {
    return ___EmotionJSX(Text, {
      textStyle: "body2",
      color: "conditional.negative.text",
      key: index
    }, error);
  }))) : helpText ? ___EmotionJSX("div", {
    css: theme.field.getCSS({
      targetElement: "helpText"
    }),
    id: auxId
  }, ___EmotionJSX(Text, {
    textStyle: "body2"
  }, helpText)) : null);
}

Field.propTypes = {
  fullWidth: PropTypes.bool,
  optional: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  labelId: PropTypes.string,
  labelFor: PropTypes.string,
  label: PropTypes.node,
  hideLabel: PropTypes.bool,
  renderLabel: PropTypes.bool,
  auxId: PropTypes.string.isRequired,
  helpText: PropTypes.node,
  errors: PropTypes.arrayOf(PropTypes.node),
  children: PropTypes.node.isRequired,
  testId: PropTypes.string
};
export default Field;